// tslint:disable
import { Component, Injector } from "@angular/core";

import { CMFormComponent } from "../../@cmcore/component/cmform/cmform.component";

import {
  CMFormGlobaisComponent,
  CMFormModalComponent,
  CMGridEditConfig,
  CMInputConfig,
  CMGridEditConfigColumn,
  CMGridEditConfigMore,
} from "../../@cmcore/component";
import {
    DuplicataReceberBrowseComponent,
} from "../index";
@Component({
  selector: "duplicata-receber-relatorios",
  templateUrl: "duplicata-receber-relatorios.component.html",
  styleUrls: ["duplicata-receber-relatorios.component.scss"],
})
export class DuplicataReceberRelatoriosComponent extends CMFormComponent {
  _owner: DuplicataReceberBrowseComponent = undefined;

  get owner() {
    return this._owner;
  }

  private static relatoriosCustomizados: any = [];

  static addRelatorioCustomizado(item: any){
    DuplicataReceberRelatoriosComponent.relatoriosCustomizados.push(item);
  }

  static getRelatorioCustomizados(){
    return DuplicataReceberRelatoriosComponent.relatoriosCustomizados;
  }

  teste = 0;

  dados = {
    tiporelatorio: "DuplicataReceberPadrao",
  };

  config = {
    tiporelatorio: new CMInputConfig({
                                    form: this,
                                    values: [
                                      {value: "DuplicataReceberPadrao", text: "Conta a Receber Padrão"},
                                    ],
                                  }),
  };

  Imprimir(){
    
    if (this.dados.tiporelatorio === "DuplicataReceberPadrao"){
        let data = { id: this.owner.grid.fieldByName(this.owner.fieldNameId()) };
        console.log(data);
        data = this.owner.getDataPrint(data);
        this.showRelat(
          "/Print",
          data,
          "duplicatareceber"
        );
    }
    else{
      let data = { 
        id: this.owner.grid.fieldByName(this.owner.fieldNameId()),
        idrelatorio: this.dados.tiporelatorio
      };
      console.log(data);
      data = this.owner.getDataPrint(data);
      this.showRelat(
        "/ImpressaoDuplicataReceberCustomizado",
        data,
        "duplicatareceber"
      );
      
    }
  }

  podeCadastrarProduto: boolean = false;
  set owner(value) {
    this._owner = value;
  }

  constructor(_injector: Injector) {
    super(_injector);
    console.log('construtor');
    this.config.tiporelatorio.values.push.apply(this.config.tiporelatorio.values, DuplicataReceberRelatoriosComponent.relatoriosCustomizados)
  }


  close(formName) {
    if (this.owner) this.owner.beforeComponent = undefined;
    CMFormModalComponent.close(formName);
  }
}
